// extracted by mini-css-extract-plugin
export default {"container":"Cp-z","heading":"Dp-z","text":"Ep-z","info":"Fp-z","link":"Gp-z","fullMaxWidth":"Hp-z"};